import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setIsContentDonated = mutatorAction(
    'setIsContentDonated',
    (isContentDonated: boolean) => {
        let store = inlineFeedbackDialogStore();
        store.isContentDonated = isContentDonated;
    }
);
